module.exports = __webpack_public_path__ + "dimer/static/img/21.4f587a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/21.jpg
// module id = K5F8
// module chunks = 0